<template>
	<popupLayout :popupClass="'mb-lg'">
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
		<div class="bootbox-body">
			<h4>選擇負責人員（已選 {{checkedAccounts.length}} / 10 人）</h4>
			<div class="row form-group">
				<div class="col-md-12">
					<div v-if="!stuList || stuList.length == 0" class="text-center">該樓層目前無住宿生名單</div>
					<div v-for="(stu, key) in stuList" :key="key" class="checkbox-custom checkbox-danger">
						<input type="checkbox" :id="'staff_' + stu.account" :value="stu.account" v-model="checkedAccounts"
							:disabled="checkedAccounts.length >= 10 && checkedAccounts.indexOf(stu.account) == -1">
						<label :for="'staff_' + stu.account">{{stu.label}}</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-offset-2 col-md-4">
					<a class="btn btn-danger btn-block" @click="confirmSelection">確認</a>
				</div>
				<div class="col-md-4">
					<a class="btn btn-default btn-block" @click="closePopup">取消</a>
				</div>
			</div>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:['stuList', 'initStaffList'],
	data(){
		return {
			checkedAccounts: (this.initStaffList || []).map(s => s.account)
		};
	},
	methods:{
		confirmSelection(){
			if(this.checkedAccounts.length == 0){
				bootbox.alert("請選擇負責人員");
				return;
			}
			let list = (this.stuList || []).filter(s => this.checkedAccounts.indexOf(s.account) > -1);
			this.$parent.applyStaffSelection(list);
		},
		closePopup(){
			this.$parent.staffPopupControl(false);
		}
	}
}
</script>
<style scoped>
.bootbox-body{
	max-height:70vh;
	overflow-y:auto;
}
</style>
